/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import ParseContent from 'components/shared/ParseContent'
import Hero from 'components/elements/Hero'
import Contact from 'components/sidebar/Contact'
import KoelMonteurs from 'components/shared/before-footer/Koelmonteurs'

export const pageQuery = graphql`
  query($id: String) {
    page: wpProject(id: { eq: $id }) {
      title
      uri
      postProject {
        projectbanner {
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality:100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          title
        }
        text {
          description
        }
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const ProjectDetailTemplate = ({
  data: {
    page: {
      seo,
      postProject,
    },
  },
}) => {
  return (
    <Layout>
      {seo && (
        <SEO seo={seo} socialImage={postProject.projectbanner.image.localFile.childImageSharp.meta.src} />
      )}

      <Hero src={postProject.projectbanner.image} title={postProject.projectbanner.title} />

      <div className="container py-5 mb-5">
        <div className="row">
          <div className="col-lg-6 pl-lg-5">
            <ParseContent content={postProject.text.description} />
          </div>
          <Contact />
        </div>
      </div>
      <KoelMonteurs />
    </Layout>
  )
}

export default ProjectDetailTemplate
